import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import koraIcon from '@/assets/imgs/kora-icon.svg';

const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=5519991846639';

function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.372-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12.04 2c-5.523 0-10 4.477-10 10 0 1.77.462 3.492 1.34 5.008L2 22l5.13-1.345A9.96 9.96 0 0 0 12.04 22c5.523 0 10-4.477 10-10s-4.477-10-10-10zm0 18.15a8.13 8.13 0 0 1-4.15-1.137l-.298-.177-3.043.798.812-2.968-.194-.305A8.15 8.15 0 1 1 20.19 12.15 8.16 8.16 0 0 1 12.04 20.15z" />
    </svg>
  );
}

const BENEFITS = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.2" fill="currentColor" />
      </svg>
    ),
    title: 'Foco no que importa',
    text: 'Menos tarefas soltas, mais direção. Cada objetivo aponta pro mesmo lugar.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 20h18" />
        <rect x="6" y="12" width="3" height="8" />
        <rect x="11" y="7" width="3" height="13" />
        <rect x="16" y="3" width="3" height="17" />
      </svg>
    ),
    title: 'Progresso visível',
    text: 'Qualquer pessoa entende, num relance, se a empresa está indo bem.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
        <circle cx="10" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'Time alinhado',
    text: 'Todo mundo enxerga a mesma prioridade, do time à liderança.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
      </svg>
    ),
    title: 'Menos reunião',
    text: 'Acompanhamento simples substitui hora de reunião de status.',
  },
];

const STEPS = [
  { num: 1, title: 'Defina a meta', text: 'Descreva em uma frase o que a empresa quer alcançar. Sem jargão, sem planilha.' },
  { num: 2, title: 'Acompanhe o progresso', text: 'Cada time atualiza o próprio andamento. Você vê tudo num só lugar, sempre atualizado.' },
  { num: 3, title: 'Celebre o resultado', text: 'Comemore o que deu certo e ajuste rápido o que não deu, sem esperar o fim do trimestre.' },
];

const GOALS = [
  { label: 'Crescer a base de clientes', pct: 78 },
  { label: 'Elevar a satisfação do time', pct: 62 },
  { label: 'Lançar a nova linha', pct: 45 },
  { label: 'Reduzir custo operacional', pct: 90 },
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar no WhatsApp"
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105"
      >
        <WhatsAppIcon className="h-7 w-7" />
      </a>

      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#161616]/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-2.5">
            <img src={koraIcon} alt="kora" className="h-9 w-9 rounded-lg" />
            <div className="leading-tight">
              <p className="font-display text-lg font-bold text-white">kora</p>
              <p className="text-[9px] font-semibold uppercase tracking-widest text-white/55">gestão estratégica</p>
            </div>
          </div>
          <nav className="hidden gap-8 md:flex">
            <a href="#beneficios" className="text-sm font-medium text-white/75 hover:text-white">Benefícios</a>
            <a href="#como-funciona" className="text-sm font-medium text-white/75 hover:text-white">Como funciona</a>
            <a href="#depoimento" className="text-sm font-medium text-white/75 hover:text-white">Depoimentos</a>
          </nav>
          <div className="flex items-center gap-4">
            <Link to="/login" className="text-sm font-medium text-white/70 hover:text-white">
              Entrar
            </Link>
            <Button asChild className="bg-primary font-semibold text-primary-foreground hover:bg-primary/90">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">Agendar uma conversa</a>
            </Button>
          </div>
        </div>
      </header>

      <section className="relative overflow-hidden bg-[#161616] py-24 text-white">
        <div
          className="pointer-events-none absolute -top-56 left-1/2 h-[900px] w-[900px] -translate-x-1/2 rounded-full opacity-60"
          style={{ background: 'radial-gradient(circle, hsl(var(--primary) / 0.45), transparent 70%)' }}
        />
        <div
          className="pointer-events-none absolute -bottom-64 -right-40 h-[640px] w-[640px] rounded-full opacity-40"
          style={{ background: 'radial-gradient(circle, hsl(var(--primary) / 0.3), transparent 70%)' }}
        />
        <div className="relative z-10 mx-auto grid max-w-6xl gap-16 px-6 md:grid-cols-[1.1fr_0.9fr] md:items-center">
          <div>
            <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary/40 bg-primary/15 px-3.5 py-1.5 text-[13px] font-semibold text-primary">
              ✦ Gestão estratégica, sem planilha
            </span>
            <h1 className="font-display text-4xl font-bold leading-tight tracking-tight lg:text-5xl">
              Sua estratégia, finalmente <span className="text-primary">saindo do papel.</span>
            </h1>
            <p className="mt-5 max-w-lg text-lg text-white/70">
              O kora transforma metas soltas em objetivos claros que todo mundo entende, acompanha e ajuda a alcançar — sem depender de planilha, reunião infinita ou achismo.
            </p>
            <div className="mt-8 flex flex-wrap gap-3.5">
              <Button asChild size="lg" className="bg-primary font-semibold text-primary-foreground hover:bg-primary/90">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">Quero conhecer o kora</a>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white/35 bg-transparent text-white hover:bg-white/10">
                <a href="#como-funciona">Ver como funciona</a>
              </Button>
            </div>
            <div className="mt-9 flex items-center gap-3.5 text-[13px] text-white/55">
              <div className="flex">
                {['A', 'M', 'L'].map((letter, i) => (
                  <span
                    key={letter}
                    className="-ml-2 flex h-7 w-7 items-center justify-center rounded-full border-2 border-[#161616] bg-gradient-to-br from-primary to-[#8a6a2c] text-[11px] font-bold text-[#2a2210] first:ml-0"
                    style={{ zIndex: 3 - i }}
                  >
                    {letter}
                  </span>
                ))}
              </div>
              <span>Equipes que trocaram a bagunça de metas por clareza real</span>
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-[#232323] p-7 shadow-2xl">
            <div className="mb-5 flex items-center justify-between">
              <p className="font-display text-sm font-bold text-white">Metas do trimestre</p>
              <span className="text-xs text-white/40">Atualizado hoje</span>
            </div>
            {GOALS.map((goal, i) => (
              <div
                key={goal.label}
                className={`flex items-center gap-3.5 py-3.5 ${i < GOALS.length - 1 ? 'border-b border-white/[0.06]' : ''}`}
              >
                <span className="h-2 w-2 flex-none rounded-full bg-primary" />
                <span className="flex-1 text-[13.5px] font-medium text-white/85">{goal.label}</span>
                <span className="h-1.5 w-28 flex-none overflow-hidden rounded-full bg-white/[0.09]">
                  <span
                    className="block h-full rounded-full bg-gradient-to-r from-[#8a6a2c] to-primary"
                    style={{ width: `${goal.pct}%` }}
                  />
                </span>
                <span className="w-9 flex-none text-right text-xs text-white/50">{goal.pct}%</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="beneficios" className="bg-background py-24">
        <div className="mx-auto max-w-6xl px-6">
          <div className="mx-auto mb-14 max-w-xl text-center">
            <p className="mb-3 text-[13px] font-bold uppercase tracking-widest text-primary">Por que o kora</p>
            <h2 className="font-display text-3xl font-bold tracking-tight">Tudo o que sua empresa precisa pra remar na mesma direção</h2>
            <p className="mt-3.5 text-muted-foreground">Nada de módulo complicado. É clareza sobre o que importa, visível pra todo mundo, o tempo todo.</p>
          </div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {BENEFITS.map((b) => (
              <div key={b.title} className="rounded-2xl border border-border bg-card p-6">
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
                  <span className="h-5.5 w-5.5 [&>svg]:h-[22px] [&>svg]:w-[22px]">{b.icon}</span>
                </div>
                <h3 className="mb-2 font-display text-[17px] font-semibold">{b.title}</h3>
                <p className="text-[14.5px] text-muted-foreground">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="como-funciona" className="bg-[#161616] py-24 text-white">
        <div className="mx-auto max-w-6xl px-6">
          <div className="mx-auto mb-14 max-w-xl text-center">
            <p className="mb-3 text-[13px] font-bold uppercase tracking-widest text-primary">Simples assim</p>
            <h2 className="font-display text-3xl font-bold tracking-tight text-white">Do objetivo ao resultado, em três passos</h2>
            <p className="mt-3.5 text-white/60">Sem curva de aprendizado. Se o time sabe usar WhatsApp, sabe usar o kora.</p>
          </div>
          <div className="grid grid-cols-1 gap-7 md:grid-cols-3">
            {STEPS.map((step) => (
              <div key={step.num} className="rounded-2xl border border-white/10 bg-[#232323] p-8">
                <div className="mb-5 flex h-9 w-9 items-center justify-center rounded-[10px] bg-primary font-display text-[15px] font-bold text-[#2a2210]">
                  {step.num}
                </div>
                <h3 className="mb-2.5 font-display text-lg font-semibold text-white">{step.title}</h3>
                <p className="text-[14.5px] text-white/60">{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="depoimento" className="bg-primary/10 py-24">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <p className="mb-6 text-xl tracking-[4px] text-primary">★★★★★</p>
          <blockquote className="font-display text-2xl font-semibold leading-snug text-foreground">
            "Trocamos oito planilhas e uma reunião semanal por uma tela que qualquer pessoa da empresa entende. Foi a mudança mais simples com maior impacto que já fizemos."
          </blockquote>
          <div className="mt-7 flex items-center justify-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#161616] font-display text-[15px] font-bold text-primary">
              LR
            </div>
            <div className="text-left">
              <p className="text-[14.5px] font-semibold">Lucas</p>
              <p className="text-[13px] text-muted-foreground">RMBS</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-br from-primary to-[#8a6a2c] px-6 py-20 text-center">
        <h2 className="font-display text-3xl font-bold text-[#2a2210]">Pronto pra ver sua estratégia sair do papel?</h2>
        <p className="mx-auto mt-3.5 max-w-md text-[#4a3c1f]">Marque uma conversa de 60 minutos e veja o kora rodando com um exemplo da sua empresa.</p>
        <Button asChild size="lg" className="mt-8 bg-[#161616] text-white hover:bg-black">
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">Agendar uma conversa</a>
        </Button>
      </section>

      <footer className="bg-[#161616] py-12 text-white/50">
        <div className="mx-auto max-w-6xl px-6">
          <div className="flex flex-wrap items-center justify-between gap-5 border-b border-white/10 pb-7">
            <div className="flex items-center gap-2.5">
              <img src={koraIcon} alt="kora" className="h-7 w-7 rounded-md" />
              <div className="leading-tight">
                <p className="font-display text-[15px] font-bold text-white">kora</p>
                <p className="text-[9px] font-semibold uppercase tracking-widest text-white/55">gestão estratégica</p>
              </div>
            </div>
            <div className="flex gap-6 text-[13.5px]">
              <a href="#beneficios" className="hover:text-white">Benefícios</a>
              <a href="#como-funciona" className="hover:text-white">Como funciona</a>
              <a href="#depoimento" className="hover:text-white">Depoimentos</a>
            </div>
          </div>
          <p className="mt-5 text-center text-xs text-white/35">© 2026 kora — gestão estratégica. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
